import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {RoutePath} from "../../../../../router/routerConfig/routerConfig";
import {NavigateFunction} from "react-router/dist/lib/hooks";
import {chatsAction} from "../../chatsSlice";

interface IRequestParams {
    idChat: number,
    navigate: NavigateFunction
}

export const navigateChatThunk = createAsyncThunk<void,
    IRequestParams,
    ThunkConfig<string>>(
        'chats/navigateChat',
        async ({idChat, navigate}, thunkAPI) => {
            const {dispatch} = thunkAPI;

            dispatch(chatsAction.setIsLoadingChat(true))
            try {
                navigate(`${RoutePath.chat_view}${idChat}/`)
            } finally {
                dispatch(chatsAction.setIsLoadingChat(false))
            }
        },
    );
